export default __webpack_public_path__ + "static/media/1397.f6194c36.png";